module.exports = __webpack_public_path__ + "img/Dominica.c8d38ee4.gif";